export default function ArrowLeftIcon(props) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={props?.fill || "#fff"}
        d="M14.9691 19.7256L8.15504 12.6146C7.98952 12.4433 7.90733 12.2211 7.90733 12C7.90733 11.7789 7.98952 11.5567 8.15504 11.3854L14.9691 4.27437C15.3081 3.91904 15.8706 3.90745 16.2248 4.24774C16.5812 4.58571 16.5928 5.15052 16.2514 5.50353L10.0274 12L16.2514 18.4965C16.5928 18.8483 16.5812 19.4143 16.2248 19.7523C15.8706 20.0925 15.3081 20.081 14.9691 19.7256Z"
      />
    </svg>
  )
}
